import {
  PermissionValues,
  useCurrentAccount,
  useLogout,
} from '@gripp/shared-logic';
import { Button, CardButton, CustomAlert } from '@gripp/shared-ui';
import { smallPadding } from 'libs/shared-ui/src/styles/spacing';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { useLocation, useNavigate } from 'react-router';
import { WorkspacesUser } from '../components/workspacesUser';

export const SettingMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentSettingPage =
    location.pathname.replace('/settings/', '') || 'profile';
  const [confirmSignOutVisible, setConfirmSignOutVisible] = useState(false);
  const logout = useLogout();
  const { account } = useCurrentAccount();
  const canManageApiKey =
    account?.hasPermission(PermissionValues.workspace.all) ?? false;

  const onPress = (page: string) => {
    navigate(page);
  };

  const onLogout = () => {
    logout().then(() => {
      navigate('/');
    });
  };

  return (
    <View style={styles.container}>
      <View>
        <WorkspacesUser />
      </View>
      <View>
        <View style={styles.settingsContainer}>
          <Text variant="bodyLarge">{t('preferences.menu.title')}</Text>
          <CardButton
            showAvatars={false}
            leftIcon={'Profile'}
            text={t('preferences.settings.profile')}
            onPress={() => onPress('/settings/profile')}
            active={currentSettingPage === 'profile'}
            bordered={false}
          />
          <CardButton
            showAvatars={false}
            leftIcon={'Settings'}
            text={t('preferences.settings.notifications')}
            onPress={() => onPress('/settings/notifications')}
            active={currentSettingPage === 'notifications'}
            bordered={false}
          />
          {canManageApiKey && (
            <CardButton
              showAvatars={false}
              leftIcon={'Link'}
              text={t('preferences.settings.apiKey')}
              onPress={() => onPress('/settings/api')}
              active={currentSettingPage === 'api'}
              bordered={false}
            />
          )}

          <Button
            onPress={() => setConfirmSignOutVisible(true)}
            state="outline"
            style={styles.singOut}
            size="large"
          >
            {t('signOut')}
          </Button>
        </View>
      </View>
      <CustomAlert
        visible={confirmSignOutVisible}
        hideAlert={() => setConfirmSignOutVisible(false)}
        action={onLogout}
        title={t('topNav.customAlert.signOut')}
        primaryButtonLabel={t('topNav.customAlert.yes')}
        secondaryButtonLabel={t('topNav.customAlert.cancel')}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 12,
    paddingHorizontal: smallPadding.paddingHorizontal,
    paddingVertical: smallPadding.paddingVertical,
  },
  settingsContainer: {
    gap: 12,
  },
  singOut: {
    borderRadius: 2,
  },
});
